import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '中间件实例',
    type: 'MIDINS_',
}
